var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/components/SendButton/SendButton.jinja"] = require( "front/components/SendButton/SendButton.jinja" );




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/Discount/Discount.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"Discount\">\n    <div class=\"Discount-content\">\n        <div class=\"Discount-title\">Скидка 10% на&nbsp;услуги для&nbsp;новых клиентов</div>\n        <div class=\"Discount-text\">Даём дополнительные 5% ветеранам, многодетным семьям, родителям-одиночкам,\n            малоимущим, пенсионерам и людям с инвалидностью любой степени\n        </div>\n    </div>\n    <div class=\"Discount-call\">\n        <div class=\"Discount-callTitle\">Заказать обратный звонок</div>\n        <input class=\"Discount-name\" placeholder=\"Как к вам обращаться\" name=\"name\" id=\"name\">\n        <input class=\"Discount-phone\" placeholder=\"Ваш номер телефона\" name=\"phone\" id=\"phone\">\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("front/components/SendButton/SendButton.jinja", false, "assets/app/front/components/Discount/Discount.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
callback(null,t_1);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_4,t_3) {
if(t_4) { cb(t_4); return; }
callback(null,t_3);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n        <div class=\"Discount-callTime\">Перезвоним <span>сегодня до 18:00</span></div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/Discount/Discount.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Discount/Discount.jinja
// module id = 13
// module chunks = 0